import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".mp-input-label-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("label", { sel: ".mp-input-label", attrs: {
    for: this.attr("field-id")
  } }, this.attr("label")), this.attr("necessary") ? /* @__PURE__ */ jsx("span", { sel: ".mp-input-necessary" }, this.attr("necessary")) : null, this.attr("help-text") ? /* @__PURE__ */ jsx("div", { sel: ".mp-input-help-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "max-width": "500px"
  } }, this.attr("help-text"))) : null, this.attr("extra-info") ? /* @__PURE__ */ jsx("div", { sel: ".mp-input-extra-info" }, this.attr("extra-info")) : null);
}
